import { useState } from 'react';

import { Search } from '@components/search/search-input';
import { SearchIcon } from '@assets/icons';
import { useStyles } from './styles';
import { Box } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const LicensesSearch = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const [text, setText] = useState('');

  return (
    <Box className={classes.searchWrapper}>
      <Search
        fullSize
        placeholder={t('license.searchActivations')}
        value={text}
        setSearch={setText}
        icon={<SearchIcon />}
        className={classes.search}
      />
    </Box>
  );
};
